var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreencheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.033 26.32a.478.478 0 01-.338.14.459.459 0 01-.357-.14l-4.697-4.706a.455.455 0 010-.66.452.452 0 01.657 0l4.387 4.396 10.014-10.042a.466.466 0 01.668 0 .474.474 0 010 .659L18.033 26.32z",
    fill: "#089B80"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "#089B80"
  })));
}
SvgGreencheck.displayName = 'Greencheck';
export default SvgGreencheck;